import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicSummaryIO = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Summary"
      takeaways={[
        { text: "From this module, DMA is the most important topic. Learn that first." },
        { text: "Focus on the remaining topics only after mastering DMA." }
      ]}
      videos={[]} // No videos provided
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicSummaryIO;
